import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    remitentes: [],
    remitentesMostrador: [],
    totalPaginas: 5,
  },
  mutations: {

    getRemitentes(state, datos) {
      state.remitentes = datos;
    },
    getRemitenteMostrador(state, datos) {
      state.remitentesMostrador = datos;
    },
    getPag(state, datos) {
      state.totalPaginas = datos;
    },

    destroyRemitentes(state) {
      state.remitentes = [];
      state.totalPaginas = 5;
    },


    destroyRemitentesMostrador(state) {
      state.remitentesMostrador = [];
      state.totalPaginas = 5;
    },
  },
  actions: {
    async getRemitentes({
      commit,
    }, rem) {
      try {
        const res = await api.getRemitentes(rem);
        if (res.data.DATOS) {
          commit('getPag', res.data.INFO.paginacion.Paginas);
          commit('getRemitentes', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async getRemitenteMostrador({
      commit,
    }, rem) {
      try {
        const res = await api.getRemitenteMostrador(rem);
        // console.log(object);
        if (res.data.INFO.cod === '200') {
          commit('getRemitenteMostrador', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async destroyRemitentes({ commit }) {
      commit('destroyRemitentes');
    },

    async destroyRemitentesMostrador({ commit }) {
      commit('destroyRemitentesMostrador');
    },

    async insertRemitentes({ }, rem) {
      try {
        const res = await api.insertRemitentes(rem);
        if (res.data.INFO.cod === '200') {
          return [true, res.data.remitente.ID, [res.data.remitente.TARIFA_CLIENTE, res.data.remitente.TARIFA_GENERAL]];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        return [false, 'errorcarga']
      }
    },

    async updateTarifasRemitentes({ commit }, rem) {
      try {
        const res = await api.updateTarifasRemitentes(rem);
        if (res.data.INFO.cod == '200') {
          if (res.data.tarifas.length == 2) {
            console.log('llamamos commit 1', res.data.tarifas[1]);
            commit('enviosRemitentes/chargeRemitenteUpdatedTarifa', res.data.tarifas[1], { root: true });
          } else if (res.data.tarifas.length == 1) {
            console.log('llamamos commit 2', res.data.tarifas[0]);
            commit('enviosRemitentes/chargeRemitenteUpdatedTarifa', res.data.tarifas[0], { root: true });
          }
          return true;
          //commit('enviosRemitentes/chargeRemitenteUpdatedTarifa', '', { root: true });
          // return [true, res.data.remitente.ID];
        }
        // return [false, res.data.INFO.msg];
      } catch (error) {
        return [false, 'errorcarga']
      }
    },

    async deleteRemitentes({ }, dest) {
      try {
        const res = await api.deleteRemitentes(dest);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async editRemitentes({ }, remi) {
      try {
        const res = await api.editRemitentes(remi);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO];
      } catch (error) {
        return [false, 'errorcarga']
      }
    },

  },
};
